import {branch as branchHOC, renderComponent} from 'recompose'

import compose from 'lodash/flowRight'
import * as React from 'react'
import {useCallback} from 'react'
import {connect} from 'react-redux'

import withEffect from '../../../../../hocs/withEffect'
import withHook from '../../../../../hocs/withHook'
import type {State} from '../../../../../reducers/types'
import {useBranchesWithBuildsArg} from '../../../../../rest/branchesWithBuilds'
import {getBuildType} from '../../../../../selectors'
import {restApi} from '../../../../../services/rest'
import type {BuildTypeId, BuildTypeInternalId} from '../../../../../types'
import {subscribeOnBuildTypeEvents} from '../../../../../utils/subscriber'
import * as SubscriptionEvents from '../../../../../utils/subscriptionEvents'
import Loader from '../../../../common/Loader/Loader'

import BuildTypeBranches from './BuildTypeBranches'

type OwnProps = {
  buildTypeId: BuildTypeId
}
type StateProps = {
  internalId: BuildTypeInternalId | null | undefined
}
type HookProps = {
  isLoading: boolean
  fetchCurrentBranches: () => unknown
}
type Props = OwnProps & StateProps & HookProps

const mapStateToProps = (state: State, {buildTypeId}: OwnProps): StateProps => ({
  internalId: getBuildType(state, buildTypeId)?.internalId,
})

const Events = [
  SubscriptionEvents.BUILD_TYPE_ADDED_TO_QUEUE,
  SubscriptionEvents.BUILD_TYPE_REMOVED_FROM_QUEUE,
  SubscriptionEvents.BUILD_STARTED,
  SubscriptionEvents.BUILD_FINISHED,
  SubscriptionEvents.BUILD_INTERRUPTED,
  SubscriptionEvents.BUILD_REMOVED,
  SubscriptionEvents.BUILD_CHANGES_LOADED,
  SubscriptionEvents.BUILD_TAGS_CHANGED,
  SubscriptionEvents.BUILD_TYPE_BRANCHES_CHANGED,
]
export default compose(
  connect(mapStateToProps),
  withHook((): HookProps => {
    const arg = useBranchesWithBuildsArg()
    const [fetchBranches, {isLoading}] =
      restApi.endpoints.getAllBranchesOfBuildTypeMerged.useLazyQuery({
        selectFromResult: ({data}) => ({isLoading: data == null}),
      })
    const fetchCurrentBranches = useCallback(() => fetchBranches(arg), [arg, fetchBranches])
    return {fetchCurrentBranches, isLoading}
  }),
  withEffect(
    (props: Props) => props.fetchCurrentBranches,
    (props: Props) => props.internalId,
    (fetchCurrentBranches: () => unknown, internalId: BuildTypeInternalId | null | undefined) =>
      internalId != null
        ? subscribeOnBuildTypeEvents(internalId, Events, fetchCurrentBranches)
        : undefined,
  ),
  branchHOC(
    (props: Props) => props.isLoading,
    renderComponent(() => <Loader />),
  ),
)(BuildTypeBranches)
